import React, { useEffect } from 'react';
import SafeIcon from '../../../common/SafeIcon';
import { Icons } from '../../../shared/icons';

export default function EngineerStep({ 
  form, 
  setField,
  authUser,
  errors = {}
}) {
  // Auto-fill engineer details from auth user
  useEffect(() => {
    if (authUser && !form.engineer_name) {
      setField('engineer_name', authUser.name || '');
    }
    if (authUser && !form.engineer_registration_number) {
      setField('engineer_registration_number', authUser.gas_safe_number || '');
    }
  }, [authUser, form.engineer_name, form.engineer_registration_number, setField]);

  const handleRegNumberChange = (e) => {
    let value = e.target.value.replace(/\D/g, ''); // Remove non-digits
    if (value.length > 8) value = value.slice(0, 8); // Max 8 digits
    setField('engineer_registration_number', value);
  };

  return (
    <div className="engineer-step">
      <div className="panel engineer-panel">
        <h3>Engineer Details</h3>
        <p className="field-hint">Your Gas Safe registration information is required on all certificates</p>
      </div>

      <label className="cert-field">
        Engineer Name
        <input
          type="text"
          value={form.engineer_name}
          onChange={(e) => setField('engineer_name', e.target.value)}
          placeholder="Your full name"
          required
          aria-label="Engineer name"
          className={errors.engineer_name ? 'error' : ''}
        />
        {errors.engineer_name && (
          <span className="error-message">{errors.engineer_name}</span>
        )}
      </label>

      <label className="cert-field">
        Gas Safe Registration Number
        <input
          type="tel"
          inputMode="numeric"
          value={form.engineer_registration_number}
          onChange={handleRegNumberChange}
          placeholder="7-8 digit number (e.g. 1234567)"
          required
          aria-label="Gas Safe registration number"
          className={errors.engineer_registration_number ? 'error' : ''}
          maxLength={8}
        />
        {errors.engineer_registration_number ? (
          <span className="error-message">{errors.engineer_registration_number}</span>
        ) : (
          <span className="field-hint">
            <SafeIcon icon={Icons.Info} size={14} />
            Your 7-8 digit Gas Safe number (GS + digits is optional)
          </span>
        )}
      </label>

      <label className="cert-field">
        Employing Business Name
        <input
          type="text"
          value={form.business_name}
          onChange={(e) => setField('business_name', e.target.value)}
          placeholder="Registered business name"
          required
          aria-label="Employing business name"
          className={errors.business_name ? 'error' : ''}
        />
        {errors.business_name && (
          <span className="error-message">{errors.business_name}</span>
        )}
      </label>

      <label className="cert-field">
        Business Address
        <textarea
          value={form.business_address}
          onChange={(e) => setField('business_address', e.target.value)}
          placeholder="Full business address"
          rows={2}
          aria-label="Business address"
        />
      </label>

      <label className="cert-field">
        Business Phone
        <input
          type="tel"
          inputMode="tel"
          value={form.business_phone}
          onChange={(e) => setField('business_phone', e.target.value)}
          placeholder="Contact phone number"
          aria-label="Business phone number"
        />
      </label>

      <div className="panel info-panel">
        <SafeIcon icon={Icons.Info} size={20} />
        <p className="field-hint">
          These details will appear on the final certificate. Ensure your Gas Safe number is correct.
        </p>
      </div>
    </div>
  );
}